class QuoteCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.pebbl-quote-carousel__track');
    this.buttons = this.querySelectorAll('.pebbl-quote-carousel__button');
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.scrollByDirection(button.dataset.direction));
    });
  }

  scrollByDirection(direction) {
    if (!this.track) return;
    const slideWidth = this.track.clientWidth;
    this.track.scrollBy({
      left: direction === 'next' ? slideWidth : -slideWidth,
      behavior: 'smooth',
    });
  }
}

customElements.define('quote-carousel', QuoteCarousel);
